import React, { useState, useEffect } from 'react';
import { Chart } from 'react-google-charts';
import { useColorMode, Box, Select } from '@chakra-ui/react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
//import { ejemplo } from './datosEjemplo'

const BarGraph = ({ data: rawData }) => {
    //const rawData = ejemplo;
    const { colorMode } = useColorMode();
    const isDarkMode = colorMode === 'dark';

    const convertDataToChartFormat = (data, groupByMonth = false) => {
        const chartData = [["Time Period", "Orders", { role: 'tooltip', type: 'string', p: { html: true } }]];

        if (groupByMonth) {
            const monthlyData = new Map();
            data.forEach(item => {
                const rawDate = new Date(item.date);
                const monthYear = format(rawDate, 'MMM yyyy', { locale: es });
                const currentCount = monthlyData.get(monthYear) || 0;
                monthlyData.set(monthYear, currentCount + item.count);
            });
            monthlyData.forEach((count, monthYear) => {
                chartData.push([monthYear, count, monthYear]);
            });
        } else {
            data.forEach(item => {
                const rawDate = new Date(item.date);
                const formattedDate = format(rawDate, 'd-MMM', { locale: es });
                chartData.push([formattedDate, item.count, formattedDate]);
            });
        }
        return chartData;
    };

    const initialChartData = convertDataToChartFormat(rawData);
    const [timeRange, setTimeRange] = useState('last5Days');
    const [filteredData, setFilteredData] = useState(initialChartData);
    const [axisTitle, setAxisTitle] = useState('Día');


    useEffect(() => {
        filterData(timeRange);
        // eslint-disable-next-line
    }, [timeRange, rawData]);

    const handleTimeRangeChange = (e) => {
        setTimeRange(e.target.value);
    };

    const filterData = (range) => {
        let filtered = rawData;
        // Update axis title based on grouping
        const isGroupedByMonth = range === 'lastYear' || range === 'all';
        setAxisTitle(isGroupedByMonth ? 'Mes' : 'Día');

        if (range !== 'all') {
            const today = new Date();
            const oneDay = 24 * 60 * 60 * 1000; // Milliseconds in a day
            filtered = rawData.filter(item => {
                const rawDate = new Date(item.date);
                switch (range) {
                    case 'lastDay':
                        return rawDate >= new Date(today - oneDay);
                    case 'last5Days':
                        return rawDate >= new Date(today - 5 * oneDay);
                    case 'last30Days':
                        return rawDate >= new Date(today - 30 * oneDay);
                    case 'lastYear':
                        return rawDate >= new Date(today - 365 * oneDay);
                    default:
                        return true;
                }
            });
        }

        // Check if the range is 'lastYear' or 'all' and set groupByMonth accordingly
        const groupByMonth = range === 'lastYear' || range === 'all';
        const chartData = convertDataToChartFormat(filtered, groupByMonth);

        setFilteredData(chartData);
    };



    const options = {
        title: "Ordenes por día",
        hAxis: {
            title: axisTitle,
            textStyle: {
                color: isDarkMode ? '#CBD5E0' : '#2D3748',
                fontSize: 18
            },
            slantedText: true, // Enable slanted text
            slantedTextAngle: 45 // Adjust text angle (optional, default is 30 degrees)
        },
        vAxis: {
            title: 'Ordenes',
            textStyle: {
                color: isDarkMode ? '#CBD5E0' : '#2D3748',
                fontSize: 24
            },
            minValue: 0,
        },
        legend: 'none',
        bar: { groupWidth: '95%' },
        colors: ['#1b9e77'],
        backgroundColor: isDarkMode ? '#2D3748' : '#FFFFFF',
        titleTextStyle: {
            color: isDarkMode ? '#CBD5E0' : '#2D3748',
            fontSize: 24
        },
        chartArea: {
            width: '90%',
            height: '50%'
        },
        tooltip: { isHtml: true } // Ensure the tooltip uses HTML formatting
    };

    return (
        <Box m={4} p={4} w='99%' h='400px' bg={isDarkMode ? 'gray.700' : 'gray.50'} rounded="lg" boxShadow="md">
            <Select onChange={handleTimeRangeChange} placeholder="Selecciona un rango" style={{ fontSize: '24px' }}>
                <option value="lastDay">Ultimo día</option>
                <option value="last5Days">Ultimos 5 días</option>
                <option value="last30Days">Ultimos 30 días</option>
                <option value="lastYear">Ultimo año</option>
                <option value="all">Todo</option>
            </Select>
            <Chart
                chartType="ColumnChart"
                width="100%"
                height="300px"
                data={filteredData}
                options={options}
            />
        </Box>
    );
};

export default BarGraph;
